<template>
  <v-container>

    <v-skeleton-loader v-if="isLoading" type="card" class="mx-auto" max-width="90%" />

    <!--#ref Aviso notificación pendiente -->
    <v-row v-if="!isLoading && totalNotificaciones > 0">
      <v-col cols="12" md="9" class="mx-auto">
        <v-alert color="#D92727" text style="margin-bottom: 0;">
          <img src="../../assets/campana_roja.svg" height="50px" style="margin: 0 25px 0 10px; float: left;" />
          <h3 style="color: #595959; padding-left: 72px; display: block;">Tiene {{ totalNotificaciones }} {{
            totalNotificaciones > 1 ? 'notificaciones pendientes' : 'notificacion pendiente' }}</h3>
          <p style="color: #595959; margin-bottom: 0; padding-left: 72px; display: block;">Es necesario confirmar la
            recepción de todas las notificaciones para continuar con nuevos trámites.</p>
        </v-alert>
      </v-col>
    </v-row>
    <!--#endref Aviso notificación pendiente -->

    <v-row>
      <v-col class="mx-auto" cols="12" md="12" lg="12">
        <v-card flat>
          <v-card-text style="border: 1px solid #E0E0E0">

            <!-- #ref Aviso notificacion firmada -->
            <v-row v-if="notificacionFirmada" class="mx-auto mb-0 mt-4">
              <v-col cols="12" sm="8" lg="9" class="mx-auto text-center">
                <v-row class="font-weight-black px-4 py-4 align-center justify-center justify-lg-start"
                  style=" display: inline-flex;background: #3695151A;">
                  <v-img alt="logo" src="../../assets/check-green.svg" max-height="40" max-width="40" />
                  <div class="ml-2 font-weight-bold" style="font-size: 18px;"
                    :style="$vuetify.breakpoint.xs ? 'margin-bottom: 10px; float: left;' : ''">
                    La notificación se ha firmado correctamente
                  </div>
                </v-row>
              </v-col>
            </v-row>
            <!-- #endref Aviso notificacion firmada -->

            <!-- #ref bloque gestionar pendiente -->
            <v-row v-if="!isLoading && !notificacionFirmada && !errorAcceso" class="mx-auto">
              <v-col cols="12" sm="12" md="12" class="mx-auto">
                <p class="text-center font-weight-bold" style="font-size:1.3em">Le enviaremos un SMS a su teléfono
                  con un código para que pueda acceder a este documento.</p>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mx-auto mb-4">
                <FirmarDialog ref='FirmarDialog' v-bind:telefono="telefono" v-on:firmada="reload"
                  v-bind:idFirmaDocumento="idFirmaDocumento" @alert-event="event => $emit('alert-event', event)" />
              </v-col>
            </v-row>
            <!-- #endref bloque gestionar pendiente -->

            <!-- #ref bloque descargar notificacion firmada -->
            <v-row v-if="!isLoading && notificacionFirmada && !errorAcceso" class="mt-2 mb-2">
              <v-col cols="12" :md="documentosPendientes ? '12' : '12'" style="text-align: center;">
                <a href="#" @click="downloadDocument" class="text-body-1" style="color: rgba(18, 77, 145, 1);">
                  Descargar notificación
                </a>
              </v-col>
            </v-row>

            <!--
            Únicamente se muestra el botón de ver documentación asociada al expediente para los tipos de documento: 
              CATA_DANA_RESOLUCION_FAVORABLE_PROVISIONAL: 50114,
              CATA_DANA_RESOLUCION_DESFAVORABLE_PROVISIONAL: 50116
            -->
            <v-row v-if="showBotonDocAsociadaExpediente" class="mt-2">
              <v-col cols="12" md="12" class="text-center">
                <v-btn @click="continueNext" class="text-body-1 font-weight-bold btn-next col-auto mt-2"
                  color="primary">
                  Ver documentación asociada al expediente
                </v-btn>
              </v-col>
            </v-row>

            <v-row v-if="!isLoading && notificacionFirmada && !errorAcceso && visibleTextButton" class="mt-4">
              <v-col cols="12" class="text-center">
                <div class="text-body-1">
                  <b>Continúe con el siguiente paso.</b>
                </div>
                <div class="text-body-1">
                  Puede continuar en otro momento desde el correo que le acabamos de enviar
                </div>
              </v-col>
            </v-row>
            <!-- #endref bloque descargar notificacion firmada-->
            <!--#ref Error -->
            <v-alert type="error" class="mx-lg-auto" cols="12" md="8" lg="6" justify="center" v-if="errorAcceso"
              style="text-align: center;">
              No tienes acceso a esta notificación.
            </v-alert>
            <!--#endref Error -->

          </v-card-text>
          <v-card-actions>
            <v-row v-if="!isLoading && notificacionFirmada && hasNextStep && !errorAcceso && visibleTextButton"
              class="mt-2">
              <v-col cols="12" md="12" v-if="!isLoading && notificacionFirmada && !errorAcceso"
                style="text-align: center;">
                <v-btn @click="continueNext" :disabled="!descargaConfirmada"
                  class="text-body-1 font-weight-bold btn-next col-auto mt-2" color="primary">
                  Continuar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-container fluid fill-height>
            <v-row align="center" justify="center">
              <v-col cols="12" md="7" lg="5">
                <v-alert v-if="!descargaConfirmada && notificacionFirmada && !errorAcceso" class="pa-4" color="#D92727"
                  text>
                  <div class="d-flex align-center">
                    <img alt="warning" src="../../assets/warning_rojo.svg" height="30px" class="mr-3" />
                    <span class="font-weight-bold">
                      Para continuar, por favor descargue la notificación.
                    </span>
                  </div>
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import api from '@Base/services/notificacionService'
import StepBase from '@Base/pages/common/StepBase.js'
import FirmarDialog from './FirmarDialog'
import { Estados } from '../../conf/constants'
import { routeNameAfterSignNotificaction, hasNotificationNextStep } from '@Base/utils/helpers'
import { mapGetters } from 'vuex';
export default {
  name: 'NotificacionesMain',
  components: {
    FirmarDialog
  },
  mixins: [StepBase],
  data() {
    return {
      documentosPendientes: false,
      errorAcceso: false,
      idFirmaDocumento: null,
      isLoading: true,
      notificacion: null,
      notificacionFirmada: false,
      telefono: '',
      visibleTextButton: true,
      descargaConfirmada: false,
    }
  },
  computed: {
    ...mapGetters({
      tipoDocumentoAudFirma: 'solicitud/tipoDocumentoAudFirma',
    }),
    totalNotificaciones() {
      return this.$store.state.solicitud ? this.$store.state.solicitud.totalNotificaciones : 0;
    },
    tituloPasoActual() {
      return this.notificacion ? this.notificacion.decripcionDocumento : '';
    },
    descripcionPasoActual() {
      return this.notificacion ? this.formatLocalDateTime(this.notificacion.fechaEnvio) : '';
    },
    fechaFirma() {
      return this.notificacion && this.notificacion.fechaFirma ? this.formatLocalDateTime(this.notificacion.fechaFirma) : '';
    },
    datosSolicitante() {
      if (!this.$store.state.solicitud.solicitante) return '';
      var s = this.$store.state.solicitud.solicitante;

      return s.dni + " - " + s.nombre + " " + (s.apellido1 ? s.apellido1 : '') + " " + (s.apellido2 ? s.apellido2 : '');
    },
    emailSolicitud() {
      if (this.notificacion) {
        return this.notificacion.email;
      } else if (this.$store.state.solicitud.solicitante) {
        return this.$store.state.solicitud.solicitante.email;
      } else {
        return "";
      }
    },
    tokenGestion() {
      return this.$store.state.solicitud.tokenGestion;
    },
    tokenAcceso() {
      return this.$store.state.solicitud.tokenAcceso;
    },
    estadoExpediente() {
      return this.$store.state.solicitud.solicitante.estado;
    },
    showBotonDocAsociadaExpediente() {
      return !this.isLoading &&
        this.notificacionFirmada &&
        !this.errorAcceso &&
        (this.tipoDocumentoAudFirma == 50114 || this.tipoDocumentoAudFirma == 50116);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prepare(to.params.id, to.params.notificacion);
    })
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.prepare(to.params.id, to.params.notificacion);
    }
  },
  methods: {
    routeNameAfterSignNotificaction,
    hasNotificationNextStep,
    hasNextStep() {
      return this.hasNotificationNextStep(this.tipoDocumentoAudFirma);
    },
    continueNext() {
      const routeName = this.routeNameAfterSignNotificaction(this.tipoDocumentoAudFirma);
      this.$router.push({ name: routeName, params: { id: this.tokenAcceso, notificacion: this.idFirmaDocumento } });
    },
    downloadDocument() {
      api.getDocumento(this.tokenGestion, this.idFirmaDocumento,
        () => {
          this.descargaConfirmada = true;
        },
        error => {
          this.$emit('alert-event', { text: 'Error al descargar el documento', color: 'red' });
          console.log(error);
        });
    },
    reload: function () {
      this.prepare(this.$store.state.solicitud.tokenAcceso, this.idFirmaDocumento);

      this.$store.commit('solicitud/setTotalNotificaciones', 0);
    },

    prepare: function (token, idFirmaDocumento) {
      this.isLoading = true;
      this.errorAcceso = false;
      this.documentosPendientes = false;

      if (!idFirmaDocumento || !token) {
        this.$router.push({ name: 'no-direct-access' });
        return;
      }

      if (!this.tokenGestion || !this.$store.state.solicitud.solicitante || this.$store.state.solicitud.tokenAcceso != token) {
        this.$router.push({ name: 'acceso-notificacion', params: { id: token, notificacion: idFirmaDocumento } });
        return;
      }

      this.telefono = this.$store.state.solicitud.solicitante.movilContacto;
      api.getNotificacion(this.tokenGestion, idFirmaDocumento,
        res => {
          this.isLoading = false;
          this.errorAcceso = false;
          this.notificacion = res.firmaDocumento;
          this.idFirmaDocumento = this.notificacion.idFirmaDocumento;
          this.documentosPendientes = res.documentosPendientes;

          if (!this.notificacion.tipoDocumentoDestino) {
            this.visibleTextButton = false
          }

          if (this.notificacion.estadoFirma == 5) {
            this.continueNext();
            return;
          }

          if (this.notificacion.estadoFirma <= 3)
            this.notificacionFirmada = false;
          else {
            this.notificacionFirmada = true;
          }

          const sol = this.$store.state.solicitud.solicitante;
          this.$store.commit('solicitud/setTituloModulo', sol.tituloPrestacion);
        },
        error => {
          this.errorAcceso = true;
          this.isLoading = false;
          this.$emit('alert-event', { text: 'Error al obtener la notificación', color: 'red' });
          console.log(error);
        });
    }
  }
}
</script>
<style scoped>
.fontSize {
  font-size: 24px !important;
  font-family: 'Lato', sans-serif !important;
}

.fontStyle {
  color: #30629F !important;
  text-decoration: underline;
  font-size: 17px;
  font-weight: bold;
  font-family: 'Lato', sans-serif !important;
}

.v-application .text-body-1 {
  font-size: 1rem !important;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0.03125em !important;
  font-family: "Lato", sans-serif !important;
}
</style>